import * as THREE from 'three';

import {createBasicMaterial} from './stander_f.js'

const zeroM= createBasicMaterial(0x00ff00, 0); // 创建绿色半透明材质
zeroM.opacity=0
zeroM.depthWrite=false
zeroM.flatShading=false
export {zeroM}